import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/calorie-calculator',
  component: () => import('../../routes/CalorieCalculator.svelte'),
  card: {
    id: 'calorie-calculator',
    title: 'Calorie Calculator',
    description: 'Calculate your daily calorie needs for weight loss, maintenance, or gain based on your BMR, activity level, and weight goals.',
    icon: 'restaurant',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/calorie-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Calorie Calculator – Daily Calorie Needs for Weight Loss & Gain',
    description: 'Free calorie calculator to calculate your daily calorie needs for weight loss, maintenance, or muscle gain. Enter your BMR, activity level, and goals.',
  },
};

export default meta;
